import { ConfigService } from "src/app/servizi/config/config.service";
import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  OnDestroy
} from "@angular/core";
import {
  faAlignJustify,
  faUserCircle
} from "@fortawesome/free-solid-svg-icons";
import { MappaService } from "../../servizi/mappa/mappa.service";
import { GestioneLoginService } from "src/app/servizi/login/gestione-login.service";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Subscription } from "rxjs";
import { NGXLogger } from "ngx-logger";
import { GestioneUtentiService } from "src/app/servizi/utenti/gestione-utenti.service";
import FUNZIONALITA from "src/app/servizi/EBWIdFunzionalita";
// import { WebsocketService } from "src/app/servizi/websocket.service";
import { RouterService } from "src/app/servizi/router.service";

/** Application Header */
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./../../app.component.scss", "./header.component.scss"]
})
export class HeaderComponent implements OnInit, OnDestroy {
  logo: string = "";
  poweredBy: string = "";

  /** To check if the user has the permissions */
  notificationsListActive = false;
  userMenuActive = false;
  userProfileActive = false;
  userLogoutActive = false;

  /** Icons */
  faAlignJustify = faAlignJustify;
  faUserCircle = faUserCircle;
  faCalendarAlt = faCalendarAlt;

  /** EventEmitter: Click on sidebar button */
  @Output() toggle: EventEmitter<any> = new EventEmitter();

  /** Token Payload */
  userInfo;

  /** Login subscription */
  loginSubs: Subscription;

  /** Constructor */
  constructor(
    private loginServ: GestioneLoginService,
    private mappaService: MappaService,
    private gestioneUtentiService: GestioneUtentiService,
    private configService: ConfigService,
    private logger: NGXLogger,
    // private websocketService: WebsocketService,
    private routerSrv: RouterService
  ) {
    this.logo = this.configService.getConfigGlobale().styles.logoDark;
    this.poweredBy = this.configService.getConfigGlobale().styles.poweredBy;
  }

  // ------------------------------------------------------------------------------------------

  ngOnInit() {
    this.notificationsListActive = this.gestioneUtentiService.isEnabled(
      this.configService.getConfigGlobale().permissions.notificationControls
        .notificationList
    );
    this.userMenuActive = this.gestioneUtentiService.isEnabled(
      this.configService.getConfigGlobale().permissions.userControls.userMenu
    );
    this.userProfileActive = this.gestioneUtentiService.isEnabled(
      this.configService.getConfigGlobale().permissions.userControls.userProfile
    );
    this.userLogoutActive = this.gestioneUtentiService.isEnabled(
      this.configService.getConfigGlobale().permissions.userControls.userLogout
    );

    // Initialize panel with user's data
    this.initPannelloUtente();

    // Listening to a different login (eg:user simulation)
    this.loginSubs = this.loginServ.ascoltaLogin().subscribe(
      (resp: any) => {

        console.log("---> ascoltaLogin().subscribe"); // GB si può togliere?

        // Update panel with user's data
        this.initPannelloUtente();
      },
      (err: string) => {
        this.logger.error("activationError: ", err);
      }
    );
  }

  // ------------------------------------------------------------------------------------------

  /**
   * Initialize panel with user's data
   */
  initPannelloUtente() {
    this.userInfo = this.gestioneUtentiService.userGetProperties();
  }

  // ------------------------------------------------------------------------------------------

  /** 
   * Called when Open/Close the sidebar 
   * */
  toggleSidebar() {
    this.toggle.emit(null);
    // GB non c'è da nessuna parte un metodo associato all'evento emesso in refreshMappa()
    //this.mappaService.refreshMappa();
  }

  // ------------------------------------------------------------------------------------------

  // Microsoft Azure AD SSO

  onLogout() {

    // RefreshToken
    const refreshToken = this.loginServ.getRefresh();

    // Pulisce lo storage locale e di sessione
    // localStorage.clear();
    sessionStorage.clear();

    // Pulisce le informazioni dell'utente
    this.gestioneUtentiService.clearUserInfo();

    // Disconnette i WebSocket
    // this.websocketService.disconnectWS();

    // Reindirizza alla rotta di login del backend, che avvia il processo di autenticazione di Azure AD.
    window.location.href = this.loginServ.creaURL('auth', 'logout') + `?is_admin=false&refresh_token=${refreshToken}`;
  }

  /** ngOnDestroy */
  ngOnDestroy() {
    this.loginSubs.unsubscribe();
    //this.websocketService.disconnectWS();
  }
}
